module.exports = __webpack_public_path__ + "img/desk_final.e80a0936.webp";